import React from 'react'
import Button from '../../components/button'
import meteorBlue from '../../assets/images/meteor-blue.svg'

const Basic4 = () => {
  return (
    <div className='d-flex flex-column justify-content-center align-items-center h-100'>
      <div className='game-card w-50 text-center'>
        <Button to='/' title='Close Game' className='close-game-button'>
          <i className='fas fa-times'></i>
        </Button>
        <img src={meteorBlue} width='48' height='48' alt='meteor' />
        <h1 className='title'>Basic 4</h1>
        <Button to='/basic4/single'>SINGLE PLAYER</Button>
        {/*<br />
        <Button to='/basic4/multi'>MULTI PLAYER</Button>*/}
      </div>
    </div>
  )
}

export default Basic4
